(function() {

  angular
	.module('meanApp')
	.controller('departmentsCtrl', departmentsCtrl);

  departmentsCtrl.$inject = [
  '$location', 
  'departmentsManager',
  'allergensManager',
  'featuresManager',
  'Department', 
  '$rootScope', 
  'alert', 
  '$scope', 
  'confirmationModal'];

  function departmentsCtrl(
  	$location, 
  	departmentsManager, 
  	allergensManager,
  	featuresManager,
  	Department, 
  	$rootScope, 
  	alert, 
  	$scope, 
  	confirmationModal) {

	var vm = this;
	//console.log('the current user is ', $rootScope.currentUser);
	vm.departments = [];
	vm.selectedAllergens = [];
	vm.selectedFeatures = [];

	$rootScope.$watch('currentUser', function () {
		if ($rootScope.currentUser) {
			if($rootScope.currentUser.role === 'admin'){
				loadDepartments();
				loadAllergens();
				loadFeatures();
			}
			else {
				$location.path('/');
			}
		}
	}, function(err) {
		console.log(err);
	});

	var loadDepartments = function() {
		departmentsManager.getAll()
		.then(function(result) {
			vm.departments = result.collection;
		}, function(err) {
			console.log('error loafing all departments');
		});
	};

	var loadAllergens = function() {
		allergensManager.getAll()
		.then(function(result) {
			vm.initAllergens = result.collection;
			vm.allergens = result.collection;
		}, function(err) {
			console.log('error loafing all departments');
		});
	};

	var loadFeatures = function() {
		featuresManager.getAll()
		.then(function(result) {
			vm.initFeatures= result.collection;
			vm.features = result.collection;
		}, function(err) {
			console.log('error loafing all departments');
		});
	};

	vm.confirmationQuestion = 'Voulez vous vraiment supprimer ce rayon ?';
	vm.onConfirmationModalClick = function() {
		departmentsManager.delete($scope.departmentIDToDelete)
		.then(function() {
			this.$close();
	  		alert.push('success', 'Cette mesure a été supprimée définitivement de la base de données');
	  	}.bind($scope), function() {
	  		this.$close();
	  		alert.push('danger', "Cette mesure n'a pas pu être supprimée");
	  	}.bind($scope));

	};
	
	vm.removeDepartment = function(id) {
		$scope.departmentIDToDelete = id;
		$scope.modalInstance = confirmationModal.open($scope, 'departmentsCtrl');
	};

	vm.onReset= function() {
		//TODO reset the model binded
		vm.id='';
		vm.name='';
		vm.allergens.forEach(function(allergen) {
			allergen.selected = false;//reinit all the allergens
		});
		vm.features.forEach(function(feature) {
			feature.selected = false;//reinit all the allergens
		});
	};

	vm.editDepartment = function(department) {
		vm.editionMode = true;
		vm._id = department._id;
		vm.id = department.easyID;
		vm.name = department.name;
		
		vm.allergens.forEach(function(allergen) {
			allergen.selected = false;//reinit all the allergens
			//then apply the allergens from the backend
			department.probableAllergens.forEach(function(allergenBackEnd) {
				if( allergenBackEnd._id === allergen._id ) {
					allergen.selected = true;
				}
			});
		});
		
		vm.features.forEach(function(feature) {
			feature.selected = false;//reinit all the allergens
			//then apply the allergens from the backend
			department.probableFeatures.forEach(function(featureBackEnd) {
				if( featureBackEnd._id === feature._id ) {
					feature.selected = true;
				}
			});
		});
	};

	vm.onDepartmentSubmit = function() {

		if(vm.editionMode === true) {
			//retrieve the department
			departmentsManager.get(vm._id)
			.then(function(department) {
				department.update({
					easyID: vm.id,
					name: vm.name,
					probableAllergens: vm.allergens.filter(function(allergen) {
						return allergen.selected === true;
					}),
					probableFeatures: vm.features.filter(function(allergen) {
						return allergen.selected === true;
					})
				})
				.then(function() {
					alert.push('success', 'Le rayon a été mis à jour en base de données');
				}, function(error) {
					alert.push('danger', "Le rayon n'a pas été mis à jour en base de données");
				});
			});
			
		}
		else {
			if (typeof vm.id !== 'undefined' && vm.name) {
				var newDepartment = new Department({
					easyID: vm.id,
					name: vm.name,
					probableAllergens: vm.allergens.filter(function(allergen) {
						return allergen.selected === true;
					}),
					probableFeatures: vm.features.filter(function(allergen) {
						return allergen.selected === true;
					})
				});
				newDepartment.save()
				.then(function (department) {
					var instanceAllergen = departmentsManager.set(department);
					vm.departments.push(instanceAllergen);
					vm.onReset();
					alert.push('success', 'Nouveau rayon ajouté en base de données');
				}, function (error) {
					//TOOD préciser si déja en base de données ou quoi
					alert.push('danger', 'Rayon non ajouté en base de données');
				});
			}
		}
		
	};

  }

})();